import { render, staticRenderFns } from "./blank-question.vue?vue&type=template&id=4931d6ba&scoped=true"
import script from "./blank-question.vue?vue&type=script&lang=js"
export * from "./blank-question.vue?vue&type=script&lang=js"
import style0 from "./blank-question.vue?vue&type=style&index=0&id=4931d6ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4931d6ba",
  null
  
)

export default component.exports